import { Flex, Typography } from 'antd'
import React, { ReactNode } from 'react'
import { CountChip } from './count-chip'

export type PageTitleProps = {
    title: ReactNode
    subtitle?: ReactNode
    count?: number
    countLoading?: boolean
    extra?: ReactNode
    className?: string
    level?: 2 | 3 | 4 | 5
}

export function PageTitle({
    title,
    subtitle,
    count,
    countLoading,
    extra,
    className = 'mb-4',
    level = 3,
}: PageTitleProps) {
    return (
        <Flex
            justify="space-between"
            align="start"
            className={`flex-col sm:flex-row gap-3 items-stretch sm:items-start ${className}`}
        >
            <Flex
                vertical
                gap={2}
            >
                <Flex
                    align="center"
                    gap={8}
                >
                    <Typography.Title
                        level={level}
                        className="mb-0"
                    >
                        {title}
                    </Typography.Title>
                    <CountChip
                        value={count}
                        loading={countLoading}
                    />
                </Flex>
                {subtitle && <Typography.Text type="secondary">{subtitle}</Typography.Text>}
            </Flex>
            {extra && <div className="sm:ml-auto">{extra}</div>}
        </Flex>
    )
}
